import React from "react";

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-[#D4AF37]/15 bg-[#1A1A1A]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <span className="font-display text-4xl font-normal text-[#F5F5F5]">Goji</span>
          <p className="mt-4 text-sm text-[#F5F5F5]/55 leading-relaxed max-w-sm">
            A private sanctuary for considered connection. For romance, or for chosen family. Members verified. Always.
          </p>
        </div>
        <div>
          <h4 className="font-label text-[0.65rem] text-[#D4AF37] mb-5">The App</h4>
          <ul className="space-y-3 text-sm text-[#F5F5F5]/70">
            <li><a href="/pricing" className="hover:text-[#D4AF37] transition-colors">Memberships</a></li>
            <li><a href="/auth?mode=signup" className="hover:text-[#D4AF37] transition-colors">Apply</a></li>
            <li><a href="/dashboard" className="hover:text-[#D4AF37] transition-colors">Discover</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-label text-[0.65rem] text-[#D4AF37] mb-5">Privacy</h4>
          <ul className="space-y-3 text-sm text-[#F5F5F5]/70">
            <li><a href="#" className="hover:text-[#D4AF37] transition-colors">Privacy Policy</a></li>
            <li><a href="#" className="hover:text-[#D4AF37] transition-colors">Terms</a></li>
            <li><a href="#" className="hover:text-[#D4AF37] transition-colors">Safety Principles</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#D4AF37]/10 py-8 text-center font-label text-[0.6rem] text-[#F5F5F5]/35">
        © 2026 Goji — Sovereign. Verified. Quiet.
      </div>
    </footer>
  );
}
